<style lang="scss" scoped>
  .AppLayout {
  }
</style>

<template lang="pug">
  .AppLayout
    AppHeader
    router-view
    AppFooter
</template>

<script>
  import AppHeader from '../components/AppHeader';
  import AppFooter from '../components/AppFooter';

  export default {
    name: 'AppLayout',

    components: {
      AppHeader,
      AppFooter,
    },
  };
</script>



// WEBPACK FOOTER //
// src/layouts/AppLayout.vue